<script lang="ts">
	import { userAccountStore } from '$lib/stores/auth-store';
	import Hamburger from './Hamburger.svelte';
</script>

<div class="w-full bg-white h-20 lg:fixed lg:top-0 lg:left-0 z-20 shadow-xs">
	<div class="flex justify-between items-center h-full">
		<div>
			<Hamburger floatingPosition={false} />
		</div>
		<div>
			<img src="/images/smartgis-logo.png" alt="SmartGIS" class="max-w-full h-14" />
		</div>
		<div class="basis-auto">
			<div class="flex items-center gap-x-3 mr-6">
				{#if $userAccountStore.picture}
					<img
						class="w-12 h-12 rounded-full"
						src={$userAccountStore.picture}
						alt={$userAccountStore.fullname}
					/>
				{:else}
					{@const initials = $userAccountStore.fullname
						? $userAccountStore.fullname
								.split(' ')
								.map((name) => name[0])
								.join('')
								.toUpperCase()
						: ''}
					<div class="w-12 h-12 rounded-full bg-primary text-white text-xl font-medium relative">
						<p class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{initials}</p>
					</div>
				{/if}
				<div class="text-sm font-medium hidden lg:block">
					<p class="leading-4">{$userAccountStore.fullname}</p>
					<p class="text-secondary/50 leading-4 text-xs">{$userAccountStore.email}</p>
				</div>
			</div>
		</div>
	</div>
</div>
